module.exports = __webpack_public_path__ + "img/esiLogo.1ecf3668.png";